import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const postCodeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const pattern = /^(\s*|[0-9]{4})$/;
  const valid = pattern.test(control.value);
  return valid ? null : { postCode: true };
};
